module.exports = __webpack_public_path__ + "media/logoanimation.be6f4710.mp4";